<template>
  <v-menu
    offset-y
    :close-on-content-click="false"
    rounded="t-lg b-lg"
    max-width="350"
    min-width="350"
    left
  >
    <!-- TODO Notification Buttom  -->
    <template v-slot:activator="{ on, attrs }">
      <div>
        <!-- {{ getUploadBackground }} -->
        <v-badge
          v-if="getUploadBackground.length > 0"
          bottom
          color="error"
          offset-x="20"
          offset-y="45"
          :content="getUploadBackground.length"
        >
          <v-btn icon color="primary" v-bind="attrs" v-on="on">
            <v-icon>mdi-cloud-upload-outline</v-icon>
          </v-btn>
        </v-badge>
        <v-btn text icon color="primary" disabled v-else>
          <v-icon>mdi-cloud-upload-outline</v-icon>
        </v-btn>
      </div>
    </template>

    <!-- TODO Content Notification -->
    <div style="max-height: 50vh;">
      <v-card class="pa-0" style="height:100% ;width: 100%;" elevation="0">
        <uploadCard
          v-for="item in getUploadBackground"
          :key="item.id"
          :filename="item.name"
          :progress="item.progress"
          :size="item.size"
        ></uploadCard>
      </v-card>
    </div>
  </v-menu>
</template>

<script>
import uploadCard from '../../components/UploadCard.vue'
import { mapGetters } from 'vuex'
export default {
  components: {
    uploadCard
  },
  computed: {
    ...mapGetters(['getUploadBackground'])
  }
}
</script>

<style lang="scss" scoped></style>
